var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "log" },
    [
      _c(
        "basic-container",
        [
          _c(
            "avue-crud",
            {
              ref: "crud",
              attrs: {
                page: _vm.page,
                data: _vm.tableData,
                "table-loading": _vm.tableLoading,
                option: _vm.tableOption,
                permission: _vm.permissionList,
              },
              on: {
                "update:page": function ($event) {
                  _vm.page = $event
                },
                "on-load": _vm.getList,
                "search-change": _vm.searchChange,
                "refresh-change": _vm.refreshChange,
                "size-change": _vm.sizeChange,
                "current-change": _vm.currentChange,
                "row-del": _vm.handleDel,
              },
            },
            [
              _c(
                "template",
                { slot: "menuLeft" },
                [
                  _vm.permissions.sys_log_del
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: "",
                            type: "primary",
                            size: "small",
                            icon: "el-icon-download",
                          },
                          on: { click: _vm.exportExcel },
                        },
                        [_vm._v("导出\n        ")]
                      )
                    : _vm._e(),
                  _vm.permissions.sys_log_del
                    ? _c(
                        "el-button",
                        {
                          staticClass: "filter-item",
                          attrs: {
                            plain: "",
                            type: "primary",
                            size: "small",
                            icon: "el-icon-remove",
                          },
                          on: { click: _vm.handleDelLogs },
                        },
                        [_vm._v("批量删除\n        ")]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }